import { render, staticRenderFns } from "./ProfileFinishAlert.vue?vue&type=template&id=091e6a0e&scoped=true&"
import script from "./ProfileFinishAlert.vue?vue&type=script&lang=js&"
export * from "./ProfileFinishAlert.vue?vue&type=script&lang=js&"
import style0 from "./ProfileFinishAlert.vue?vue&type=style&index=0&id=091e6a0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091e6a0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('091e6a0e', component.options)
    } else {
      api.reload('091e6a0e', component.options)
    }
    module.hot.accept("./ProfileFinishAlert.vue?vue&type=template&id=091e6a0e&scoped=true&", function () {
      api.rerender('091e6a0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/student-profile/components/finish_alert/ProfileFinishAlert.vue"
export default component.exports